export default __webpack_public_path__ + "static/media/codigo_etica_sp.c8b17634.pdf";